var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#4c589b;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#376fa5;}.cls-6{fill:#fdcc36;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -520,
    width: 500,
    height: 500,
    rx: 115
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500,
    rx: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -296.72,
    y: -20.35,
    width: 70.22,
    height: 536.33,
    transform: "translate(-509.43 -13.79) rotate(-90)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "se"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 146.89,
    y: -9.44,
    width: 70.22,
    height: 516.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 223.28,
    y: -20.35,
    width: 70.22,
    height: 536.33,
    transform: "translate(10.57 506.21) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/se.211ed108ae5439a013a00180e450f146.svg";
export { ForwardRef as ReactComponent };